module.exports = __webpack_public_path__ + "static/media/casino.3d0adca7.png";